import { AxiosInstance } from 'axios';

import {
  AIEnablerAPIApiFactory,
  AIEnablerProvidersAPIApiFactory,
} from '@cast/openapi';

import { AXIOS_CONFIGURATION } from '../constants';

export const LLMOptimizationApiFactory = (client: AxiosInstance) => {
  const optimizerGeneratedApi = AIEnablerAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const optimizerProvidersGeneratedApi = AIEnablerProvidersAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    getSupportedProviders:
      optimizerGeneratedApi.aIEnablerAPIGetSupportedProviders,
    registerProvider:
      optimizerProvidersGeneratedApi.aIEnablerProvidersAPIRegisterProviders,
    getProviders:
      optimizerProvidersGeneratedApi.aIEnablerProvidersAPIGetProviders,
    updateProvider:
      optimizerProvidersGeneratedApi.aIEnablerProvidersAPIUpdateProvider,
    deleteProvider:
      optimizerProvidersGeneratedApi.aIEnablerProvidersAPIDeleteProvider,
  };
};
